import { whyChooseUs } from "../../../mocks/siteData";

export default function WhyChooseUs() {
  return (
    <section className="py-24 bg-[#111111] relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage:
            "repeating-linear-gradient(45deg, #C9A961 0, #C9A961 1px, transparent 0, transparent 50%)",
          backgroundSize: "20px 20px",
        }}
      ></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-4">
              Why Work With Us
            </span>
            <h2
              className="text-4xl lg:text-5xl font-semibold text-white leading-tight mb-6"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Why Homeowners Choose The Design Proposal
            </h2>
            <p className="text-white/55 leading-relaxed mb-10 max-w-lg">
              We don&apos;t give you ideas — we give you a complete, actionable plan. Every recommendation is
              budget-aligned, clearly explained, and ready to execute without hesitation.
            </p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {whyChooseUs.map((item) => (
                <div key={item.text} className="flex items-start gap-3">
                  <div className="w-8 h-8 flex items-center justify-center bg-[#C9A961]/15 rounded-lg shrink-0 mt-0.5">
                    <i className={`${item.icon} text-[#C9A961] text-sm`}></i>
                  </div>
                  <span className="text-white/75 text-sm leading-relaxed">{item.text}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="relative">
            <div className="rounded-xl overflow-hidden" style={{ height: "540px" }}>
              <img
                src="https://public.readdy.ai/ai/img_res/5f7a28508321aeba9354181749371677.jpg"
                alt="Professional interior designer reviewing proposals"
                className="w-full h-full object-cover object-top"
              />
            </div>
            <div className="absolute -bottom-5 -left-5 bg-[#C9A961] text-white p-5 rounded-xl">
              <div
                className="text-3xl font-bold mb-0.5"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                500+
              </div>
              <p className="text-sm text-white/80 whitespace-nowrap">Successful proposals delivered</p>
            </div>
            <div className="absolute -top-5 -right-5 bg-white p-5 rounded-xl border border-[#EBEBEB]">
              <div
                className="text-2xl font-bold text-[#111111] mb-0.5"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                98%
              </div>
              <p className="text-xs text-[#5C5C5C] whitespace-nowrap">Client satisfaction rate</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
